import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import RankingList from './components/RankingList';
import LatestUpdates from './components/LatestUpdates';
import { siteInfo } from '@/mocks/movies';

export default function Home() {
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${siteInfo.name} - 首页`,
    description: siteInfo.description,
    url: siteInfo.url,
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: siteInfo.url,
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategoryNav />
          <HotRecommend />
          <RankingList />
          <LatestUpdates />

          {/* CTA Section */}
          <section className="py-16 md:py-20 px-4 md:px-6">
            <div className="max-w-4xl mx-auto text-center relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-600/90 to-primary-800/90 p-10 md:p-16">
              <div className="relative z-10">
                <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-4 font-heading">
                  追剧看片，一站式搞定
                </h2>
                <p className="text-background-50/80 text-base mb-8 max-w-xl mx-auto">
                  每日更新最新电影、热门电视剧和综艺节目，高清流畅不缓冲。立即加入5000万用户的观影社区！
                </p>
                <a
                  href="/category/movie"
                  className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-primary-700 font-semibold rounded-full hover:bg-background-100 transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  开始观影
                </a>
              </div>
              <div className="absolute -top-20 -right-20 w-64 h-64 bg-accent-500/20 rounded-full blur-3xl"></div>
              <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-primary-400/20 rounded-full blur-3xl"></div>
            </div>
          </section>
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}